<template>
	<v-container>
		<v-row
			justify="center"
			align="center"
		>
			<v-col
				v-for="locale in selectableLocales"
				:key="locale.value"
				cols="auto"
			>
				<v-btn
					icon
					variant="flat"
					size="4rem"
					:elevation="locale.value !== selectedLocale ? '4' : '0'"
					@touchend="selectLocale(locale)"
					@click="selectLocale(locale)"
				>
					<v-avatar size="4rem">
						<v-img
								:lazy-src="getFlagBasedOnLocale(locale)"
								:src="getFlagBasedOnLocale(locale)"
								:cover="true"
						>
							<v-overlay
								:model-value="locale.value !== selectedLocale"
								class="scrim-opacity"
								:contained="true"
								:persistent="true"
								scrim="#FFFFFF"
							/>
						</v-img>
					</v-avatar>
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { useStore } from '../../stores/store';
import { useI18n } from 'vue-i18n';
import { languages } from '../../datas/languages.json'

export default {
	name: "LanguageSelection",
	setup() {
		const store = useStore()
		const { t, te } = useI18n()

		return {
			store,
			te,
			t
		}
	},
	data() {
		return {
			selectingLocale: false
		}
	},
	computed: {
		languages() {
			return languages
		},
		locales() {
			return this.$i18n.availableLocales
		},
		selectedLocale() {
			return this.$i18n.locale
		},
		allowedLanguages() {
			try {
				const languages = this.store.kiosk.allowedLanguages
				if(Array.isArray(languages)) {
					if(!languages.includes(this.defaultLanguage)) {
						return [ this.defaultLanguage, ...languages ]
					}
				}
				return this.store.kiosk.allowedLanguages
			} catch (e) {
				return []
			}
		},
		defaultLanguage() {
			try {
				return this.store.kiosk.defaultLanguage
			} catch (e) {
				return 'en'
			}
		},
		selectableLocales() {
			let locales = []
			for(let i = 0; i < this.locales.length; i++) {
				const locale = this.locales[i]
				if(Array.isArray(this.allowedLanguages) && this.allowedLanguages.length > 0) {
					if(!this.allowedLanguages.includes(locale)) {
						continue
					}
				}
				const foundLanguage = this.languages.find(l => l && l['iso639_1'] === locale)
				if(foundLanguage) {
					locales.push({
						label: foundLanguage.nativeName[0],
						value: locale
					})
				}
			}

			if(Array.isArray(locales)) {
				if(this.defaultLanguage) {
					const defaultLocaleIndex = locales.findIndex(locale => locale && locale.value === this.defaultLanguage)
					if(defaultLocaleIndex >= 0) {
						const defaultLocale = locales.splice(defaultLocaleIndex, 1)[0]
						locales.unshift(defaultLocale)
					} else {
						const foundDefaultLocale = this.languages.find(l => l['iso639_1'] === this.defaultLanguage)
						if(foundDefaultLocale) {
							locales.unshift({
								label: foundDefaultLocale.nativeName[0],
								value: this.defaultLanguage
							})
						}
					}
				}
			}
			return locales
		}
	},
	methods: {
		getFlagBasedOnLocale(locale) {
			if(typeof locale === 'undefined' || locale === null || typeof locale.value === 'undefined' || locale.value === null) {
				return ''
			}
			return `flags/${locale.value}.svg`
		},
		selectLocale(locale) {
			if(this.selectingLocale === true) {
				return
			}

			this.selectingLocale = true
			if(locale) {
				setTimeout(() => {
					this.$i18n.locale = locale.value
					this.selectingLocale = false
				}, 100)
			}
		},
		findLanguageInfo(locale) {
			if(locale) {
				const foundLanguage = this.languages.find(l => l && l['iso639_1'] === locale)
				if(foundLanguage) {
					return foundLanguage
				}
			}
			return null
		}
	}
}
</script>

<style scoped>
.scrim-opacity:deep(.v-overlay__scrim) {
	opacity: 0.6;
}
</style>